export const FETCH_INVOICE_REQUEST = "FETCH_INVOICE_REQUEST";
export const FETCH_INVOICE_SUCCESS = "FETCH_INVOICE_SUCCESS";
export const FETCH_INVOICE_FAILURE = "FETCH_INVOICE_FAILURE";
export const FETCH_ALL_INVOICE_REQUEST = "FETCH_ALL_INVOICE_REQUEST";
export const FETCH_ALL_INVOICE_SUCCESS = "FETCH_ALL_INVOICE_SUCCESS";
export const FETCH_ALL_INVOICE_FAILURE = "FETCH_ALL_INVOICE_FAILURE";
export const FETCH_CUSTOMER_ALL_INVOICE_REQUEST =
  "FETCH_CUSTOMER_ALL_INVOICE_REQUEST";
export const FETCH_CUSTOMER_ALL_INVOICE_SUCCESS =
  "FETCH_CUSTOMER_ALL_INVOICE_SUCCESS";
export const FETCH_CUSTOMER_ALL_INVOICE_FAILURE =
  " FETCH_CUSTOMER_ALL_INVOICE_FAILURE";
export const FETCH_VENDOR_ALL_INVOICE_REQUEST =
  "FETCH_VENDOR_ALL_INVOICE_REQUEST";
export const FETCH_VENDOR_ALL_INVOICE_SUCCESS =
  "FETCH_VENDOR_ALL_INVOICE_SUCCESS";
export const FETCH_VENDOR_ALL_INVOICE_FAILURE =
  " FETCH_VENDOR_ALL_INVOICE_FAILURE";
export const RESET_INVOICE_DETAILS = "RESET_INVOICE_DETAILS";
export const FETCH_INVOICE_VIEWS_REQUEST = "FETCH_INVOICE_VIEWS_REQUEST";
export const FETCH_INVOICE_VIEWS_SUCCESS = "FETCH_INVOICE_VIEWS_SUCCESS";
export const FETCH_INVOICE_VIEWS_FAILURE = "FETCH_INVOICE_VIEWS_FAILURE";